require('./EditFormStep.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

//@commons
const { FormattedText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const EditAddressForm = require('./EditAddressForm');
const EditPhoneForm = require('./EditPhoneForm');
const EditEmailForm = require('./EditEmailForm');
const EditFiscalDataForm = require('./EditFiscalDataForm');

//@constants
const {
    PROFILE_EDIT_CONFIG,
    PROFILE_EDIT_FORMS: {
        ADDRESS,
        EMAIL,
        FISCAL_DATA,
        PHONE
    }
} = require('constants/myProfileEditor');

//@helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

class EditFormStep extends React.Component {

    constructor(props) {
        super(props);
        this.getValidation = this.getValidation.bind(this);
        this.onHandleBlur = this.onHandleBlur.bind(this);
    }

    componentDidMount() {
        this.scrollToError();
    }

    componentDidUpdate() {
        const { immProfileEditor } = this.props;
        if (!immProfileEditor.getIn(['steps', 0, 'scrolledToError'])) {
            if (this.scrollToError()) {
                this.props.actionChangeValue({
                    scrolledToError: true
                });
            }
        }
    }

    onHandleBlur(evt) {
        const { actionChangeValue } = this.props;
        const { name, value } = evt.target;
        const trimmedValue = value.trim();
        actionChangeValue({
            [name]: trimmedValue,
            [`${name}Blur`]: true
        });
    }

    getErrorState(blur, isEmpty, isValid, isTheSameAsOriginal){
        return blur && (isEmpty || !isValid || isTheSameAsOriginal);
    }

    getValidation(name, value, blur, isValid){
        const isEmpty = !value;
        const isTheSameEmailAsOriginal = name === 'email' && PersonalDataHelper.getEmail(this.props.immProfileFields).toLowerCase() === value.toLowerCase();
        return {
            [`${name}ErrorState`]: this.getErrorState(blur, isEmpty, isValid, isTheSameEmailAsOriginal),
            [`${name}ErrorMsg`]: isEmpty ? 'incomplete' : (isTheSameEmailAsOriginal ? 'same' : 'incorrect')
        }
    }

    buildContactInformationMessage(){
        const { immProfileEditor } = this.props;
        const editMode = immProfileEditor.get('editMode');
        return (
            <div className="edit-form-step__contact-info-warning">
                <OKMessage type="informative">
                    <FormattedText value={`profile-${PROFILE_EDIT_CONFIG[editMode].editFormStep.warningSubtitleTranslation}`}/>
                </OKMessage>
            </div>
        );
    }

    buildEditForm(){
        const {
            actionChangeValue,
            deleteAdditionalCountries,
            immProfileEditor,
            immProfileFields,
            setAddingTaxAdditionalCountry,
            setEditingTaxAdditionalCountry,
            updateAdditionalCountries,
            onHandleNextDisableButton
        } = this.props;
        let editForm = null;
        const stepProps = {
            actionChangeValue,
            immProfileEditor,
            immProfileFields
        }

        switch (immProfileEditor.get('editMode')){
            case PHONE:
                editForm = (
                    <EditPhoneForm
                        getValidation={this.getValidation}
                        handleBlur={this.onHandleBlur}
                        {...stepProps}
                    />
                );
                break;
            case ADDRESS:
                editForm = (
                    <EditAddressForm
                        {...stepProps}
                        immProfileFields={immProfileFields}
                    />
                );
                break;
            case EMAIL:
                editForm = (
                    <EditEmailForm
                        getValidation={this.getValidation}
                        handleBlur={this.onHandleBlur}
                        {...stepProps}
                        immProfileFields={immProfileFields}
                    />
                );
                break;
            case FISCAL_DATA:
                editForm = (
                    <EditFiscalDataForm
                        {...stepProps}
                        onHandleNextDisableButton={onHandleNextDisableButton}
                        deleteAdditionalCountries={deleteAdditionalCountries}
                        updateAdditionalCountries={updateAdditionalCountries}
                        setEditingTaxAdditionalCountry={setEditingTaxAdditionalCountry}
                        setAddingTaxAdditionalCountry={setAddingTaxAdditionalCountry}
                    />
                );
                break;
        }
        return editForm;
    }

    buildFormError(){
        const { immProfileEditor } = this.props;
        let formError;
        const requestOtpError = immProfileEditor.get('requestOtpError') || false;
        const isRequestOtp = immProfileEditor.get('isRequestOtp') || false;

        
        if (immProfileEditor.get('validateStepError') && immProfileEditor.get('inProgress')) {
            formError = (
                <div className="edit-form-step__error-wrapper">
                    {
                        !isRequestOtp ? 
                            <OKMessage
                                id="profile-editor-message-error"
                                type="warning"
                            >
                                <>{
                                    requestOtpError ?
                                        <FormattedText value="profileEditForm-otp_email_error_address_blocked" />
                                    :
                                        <FormattedText value="profile-errorHeader" />
                                }</>
                            </OKMessage>
                        :
                            <LoadingSection />
                    }                     
                </div>
            );
        }

        return formError;
    }

    scrollToError() {
        const element = document.querySelector('.wizard__header');
        if (element) {
            window.scrollTo(0, element.offsetTop + 300);
        }
        return element;
    }

    render(){
        const { immProfileEditor } = this.props;
        const editMode = immProfileEditor.get('editMode');
        const { showContactInfoMessage, titleTranslation } = PROFILE_EDIT_CONFIG[editMode].editFormStep;

        let contactMessage;
        if (showContactInfoMessage){
            contactMessage = this.buildContactInformationMessage();
        }

        return (
            <div className="edit-form-step">
                <h4 className="edit-form-step__title">
                    <FormattedText value={`profileEditForm-${titleTranslation}`} />
                </h4>
                {contactMessage}
                {this.buildFormError()}
                {this.buildEditForm()}
            </div>
        );
    }
}

EditFormStep.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    deleteAdditionalCountries: PropTypes.func.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    updateAdditionalCountries: PropTypes.func.isRequired,
    setAddingTaxAdditionalCountry: PropTypes.func.isRequired,
    setEditingTaxAdditionalCountry: PropTypes.func.isRequired,
    onHandleNextDisableButton: PropTypes.func
};

module.exports = EditFormStep;